module.exports = __webpack_public_path__ + "img/font_family.fb18b08c.svg";